export const environment = {
    frontEndVersion: '4.6.253',
    frontEndBranch: 'master',
    timestamp: 1793367872267
};
